import React from 'react';
import UrlLink from '../../../components/UI/UrlLink/UrlLink';
import classes from './HandlingUserData.module.css';
import paths from '../../../constants/paths';

import { QUERY_PARAM_DELETE_ACCOUNT } from '../../../containers/ContactUs/ContactUsContainer';

const hu = (props) => (
  <div className={classes.Content}>
    {props.indexPage ? (
      <div>
        <p style={{ marginBottom: props.indexPage ? '1rem' : 0 }}>
          <b>Adatok letöltése</b>
        </p>
        <p>
          Az adatok letöltéséhez látogasson el a következő oldalra
          <br />
          Beállítások {'>'} Opciók {'>'} Adatkezelés {'>'} Adatok letöltése
        </p>
        <br />
        <div className={classes.HrLine} />
        <br />
      </div>
    ) : null}
    <p style={{ textAlign: props.indexPage ? 'left' : 'center' }}>
      <b>Adattörlés kérése</b>
    </p>
    <br />
    <p>Az adatok törlésének kéréséhez kövesse az alábbi lépéseket:</p>
    <br />
    <p>
      1. Menjen a{' '}
      <UrlLink
        to={`${
          props.indexPage ? paths.CONTACT_US : paths.SETTINGS__CONTACT_US
        }?${QUERY_PARAM_DELETE_ACCOUNT}`}
      >
        Kapcsolat oldalra
      </UrlLink>
      <br />
      2. Válassza a "Fiók és az összes adatom törlése" lehetőséget <br />
      3. Töltse ki az űrlapot, és nyomja meg az "Üzenet küldése" gombot <br />
      <br />
    </p>
    <p>CS csapatunk 24 órán belül törli az összes adatot.</p>
  </div>
);

export default hu;
